import { isNumeric } from './assertion.esm.js';
import toPx from './to-px.esm.js';

var scaleToPx = function scaleToPx(v) {
  if (isNumeric(v) && parseFloat("".concat(v)) < 1) {
    var retVal = Math.ceil(toPx(v));
    return "".concat(retVal % 2 === 0 ? retVal : retVal + 1, "px");
  }
  return "".concat(v);
};

export default scaleToPx;
//# sourceMappingURL=scale-to-px.esm.js.map
